import { IconLibrary, IconMappings, IconType } from "./types";

export const iconMapping: Record<string, IconMappings> = {
  [IconType.Home]: {
    [IconLibrary.GoogleMaterial as string]: "ic:baseline-home",
    [IconLibrary.MaterialSymbolsRounded as string]:
      "material-symbols:home-rounded",
    [IconLibrary.MaterialSymbols as string]: "material-symbols:home",
    [IconLibrary.FontAwesomeRegular as string]: "fa6-solid:house",
  } as IconMappings,
  [IconType.ArrowRight]: {
    [IconLibrary.GoogleMaterial as string]: "ic:baseline-arrow-forward",
    [IconLibrary.MaterialSymbolsRounded as string]:
      "material-symbols:arrow-forward-rounded",
    [IconLibrary.MaterialSymbols as string]: "material-symbols:arrow-forward",
    [IconLibrary.FontAwesomeRegular as string]: "fa6-solid:arrow-right",
  } as IconMappings,
  [IconType.ChevronRight]: {
    [IconLibrary.GoogleMaterial as string]: "ic:baseline-chevron-right",
    [IconLibrary.MaterialSymbolsRounded as string]:
      "material-symbols:chevron-right-rounded",
    [IconLibrary.MaterialSymbols as string]: "material-symbols:chevron-right",
    [IconLibrary.FontAwesomeRegular as string]: "fa6-solid:chevron-right",
  } as IconMappings,
  [IconType.ArrowLeft]: {
    [IconLibrary.GoogleMaterial as string]: "ic:baseline-arrow-back",
    [IconLibrary.MaterialSymbolsRounded as string]:
      "material-symbols:arrow-back-rounded",
    [IconLibrary.MaterialSymbols as string]: "material-symbols:arrow-back",
    [IconLibrary.FontAwesomeRegular as string]: "fa6-solid:arrow-left",
  } as IconMappings,
  [IconType.ChevronLeft]: {
    [IconLibrary.GoogleMaterial as string]: "ic:baseline-chevron-left",
    [IconLibrary.MaterialSymbolsRounded as string]:
      "material-symbols:chevron-left-rounded",
    [IconLibrary.MaterialSymbols as string]: "material-symbols:chevron-left",
    [IconLibrary.FontAwesomeRegular as string]: "fa6-solid:chevron-left",
  } as IconMappings,
  [IconType.Check]: {
    [IconLibrary.GoogleMaterial as string]: "ic:baseline-check",
    [IconLibrary.MaterialSymbolsRounded as string]:
      "material-symbols:done-rounded",
    [IconLibrary.MaterialSymbols as string]: "material-symbols:done",
    [IconLibrary.FontAwesomeRegular as string]: "fa6-solid:check",
  } as IconMappings,
  [IconType.ArrowDown]: {
    [IconLibrary.GoogleMaterial as string]: "ic:baseline-keyboard-arrow-down",
    [IconLibrary.MaterialSymbolsRounded as string]:
      "material-symbols:keyboard-arrow-down-rounded",
    [IconLibrary.MaterialSymbols as string]:
      "material-symbols:keyboard-arrow-down",
    [IconLibrary.FontAwesomeRegular as string]: "fa6-solid:angle-down",
  } as IconMappings,
};
